import React, { Component } from 'react';

class IconReportWarning extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="37"
                fill="none"
                viewBox="0 0 36 37"
            >
                <path
                    fill="#FF2929"
                    d="M17.976 33.16H7.893c-1.85 0-3.434-.647-4.578-2.125-1.413-1.809-1.73-3.837-.743-5.927.73-1.54 1.656-2.982 2.508-4.46 2.643-4.607 5.285-9.19 7.927-13.785.914-1.576 2.216-2.566 4.019-2.933 2.045-.415 4.493.526 5.589 2.298 1.108 1.784 2.13 3.617 3.19 5.45 2.448 4.253 4.895 8.505 7.343 12.745.889 1.54 1.108 3.141.536 4.84-.792 2.346-2.935 3.886-5.431 3.898-3.434.012-6.856 0-10.277 0zm-.013-2.577h10.12c1.57 0 2.74-.831 3.19-2.261.28-.904.121-1.76-.354-2.579-2.544-4.411-5.077-8.823-7.622-13.234-.901-1.564-1.778-3.153-2.74-4.693-.645-1.05-1.668-1.466-2.886-1.344-1.096.11-1.875.709-2.423 1.662L6.955 22.542c-.681 1.185-1.4 2.37-2.033 3.58-.67 1.271-.292 2.847.816 3.764.633.525 1.364.72 2.167.72 3.361-.024 6.71-.024 10.058-.024z"
                ></path>
                <path
                    fill="#FF2929"
                    d="M19.642 14.807l-.365 6.024c-.025.392-.013.795-.037 1.186-.024.525-.231.953-.73 1.185-.463.208-.89.147-1.291-.159-.33-.256-.439-.623-.463-1.014l-.329-5.902c-.036-.587-.134-1.198-.06-1.772.109-.978.876-1.577 1.74-1.503.938.06 1.535.757 1.535 1.76v.195zM16.379 26.098c0-.904.743-1.65 1.644-1.65.9 0 1.607.746 1.595 1.687-.012.88-.743 1.6-1.62 1.6a1.64 1.64 0 01-1.62-1.637z"
                ></path>
            </svg>
        );
    }
}

export default IconReportWarning;